export default [{
  path: '/aderencia-bdgd',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Aderência BDGD Histórico',
      path: 'historico',
      component: () => import('@/views/aderenciaBdgd/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Aderência BDGD' }
        ]
      },
    },
    {
      name: 'Aderência BDGD Adicionar',
      path: 'edit',
      component: () => import('@/views/aderenciaBdgd/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Aderência BDGD', path: '/aderencia-bdgd/historico' },
          { name: 'Adicionar' }
        ]
      },
    },
    {
      name: 'Aderência BDGD Visualizar Gráfico',
      path: 'grafico/:id',
      component: () => import('@/views/aderenciaBdgd/Visualizar.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Aderência BDGD', path: '/aderencia-bdgd/historico' },
          { name: 'Visualizar Gráfico' }
        ]
      },
    },
    {
      name: 'Aderência BDGD Editar',
      path: 'edit/:id',
      component: () => import('@/views/aderenciaBdgd/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Aderência BDGD', path: '/aderencia-bdgd/historico' },
          { name: 'Editar' }
        ]
      }
    }
  ]
}]